<template>
  <div>
    <div :class="{'modal':true, 'show':pickupTimeModal.show}">
      <div class="bg-overlay" @click="closePickupTimeModal"></div>
      <div class="modal-content pickup-time-modal">
        <div class="title">Edit Pickup Time</div>
        <div class="box centered" v-if="!!pickupTimeModal.message">
          <i class="fas fa-check fa-5x" v-if="pickupTimeModal.success"></i>
          <i class="fas fa-times fa-5x" v-else></i>
          <div class="res-msg">{{ pickupTimeModal.message }}</div>
          <a class="button cta xsmall block" @click="closePickupTimeModal">Close</a>
        </div>
        <div class="box" v-else>
          <datepicker :format="calendarFormat" class="datepicker inline"
            v-model="pickupTimeModalValue.date" v-on:input="changeDate"
            :disabled="disabledDate" :inline="true"></datepicker>
          <div class="row">
            <div class="columns small-4 end">
              <label>Hour</label>
              <select v-model="pickupTimeModalValue.hour" @change="updatePickupDate"
                :class="{'has-error':!!validation.pickupTime}">
                <option v-for="n in maxHour" :value="leadingZero(n)" :key="n">{{ leadingZero(n) }}</option>
              </select>
            </div>
            <div class="columns small-4 end">
              <label>Minute</label>
              <select v-model="pickupTimeModalValue.minute" @change="updatePickupDate"
                :class="{'has-error':!!validation.pickupTime}">
                <option value="00">00</option>
                <option v-for="n in 11" :value="leadingZero(n * 5)" :key="n">{{ leadingZero(n * 5) }}</option>
              </select>
            </div>
            <div class="columns small-4 end" v-if="!isMilitaryTime">
              <label>AM/PM</label>
              <select v-model="pickupTimeModalValue.amPm" @change="updatePickupDate"
                :class="{'has-error':!!validation.pickupTime}">
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>
          <span class="error-msg">{{ validation.pickupTime }}</span>
          <a :class="{'button cta xsmall success block':true, 'disabled':pickupTimeModal.loading}" @click="savePickupDate">Save</a>
          <a :class="{'button cta xsmall error block':true, 'disabled':pickupTimeModal.loading}" @click="closePickupTimeModal">Cancel</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datepicker from 'vuejs-datepicker'
import moment from 'moment-timezone'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'pickup-date-modal',
  components: { datepicker },
  data () {
    return {
      today: moment(),
      maxHour: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      validation: {
        pickupTime: ''
      }
    }
  },
  computed: {
    pickupTimeModal () { return this.$store.state.routing.packages.pickupTimeModal },
    pickupTimeModalValue () {
      let datetime = moment(this.pickupTimeModal.value, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      let hourFormat = this.$settings.get('MilitaryTimeBackoffice') === '1' ? 'HH' : 'hh'
      return {
        date: datetime.format('MM/DD/YYYY'),
        hour: datetime.format(hourFormat),
        minute: datetime.format('mm'),
        amPm: datetime.format('A')
      }
    },
    disabledDate () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
    isMilitaryTime () {
      if (this.$settings.get('MilitaryTimeBackoffice') === '1') {
        this.maxHour = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
      }
      return this.$settings.get('MilitaryTimeBackoffice') === '1'
    }
  },
  methods: {
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    closePickupTimeModal () {
      if (this.pickupTimeModal.loading) { return }
      this.$store.commit('routing/setPickupTimeModal', {
        show: false,
        loading: false,
        success: false,
        message: '',
        id: 0,
        value: ''
      })
    },
    changeDate () {
      this.pickupTimeModalValue.date = moment(this.pickupTimeModalValue.date).format('MM/DD/YYYY')
      this.updatePickupDate()
    },
    updatePickupDate () {
      let pickupDate = this.pickupTimeModalValue.date + ' ' + this.pickupTimeModalValue.hour + ':' +
        this.pickupTimeModalValue.minute + '' + this.pickupTimeModalValue.amPm
      if (this.$settings.get('MilitaryTimeBackoffice') === '1') {
        pickupDate = this.pickupTimeModalValue.date + ' ' + this.pickupTimeModalValue.hour + ':' + this.pickupTimeModalValue.minute
      }
      this.$store.commit('routing/setPickupTimeModal', { value: pickupDate })
    },
    leadingZero (n) { return n < 10 ? '0' + n : n },
    savePickupDate () {
      let self = this
      if (self.pickupTimeModal.loading) { return }

      let currentDate = moment()
      let selectedDate = moment(self.pickupTimeModal.value, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      
      self.validation.pickupTime = ''
      if (selectedDate.diff(currentDate) < 0) {
        self.validation.pickupTime = 'Pickup date must not be in the past'
        return
      }

      self.$store.commit('routing/setPickupTimeModal', { loading: true })
      self.$sdk.post(`/admin/package/${self.pickupTimeModal.id}/pickuptime`, {
        token: self.$store.state.session.sessionToken,
        pickupTime: parseInt(selectedDate.format('X'))
      }, res => {
        self.$store.commit('routing/setPickupTimeModal', { loading: false })
        if (res.error) {
          self.$store.commit('routing/setPickupTimeModal', {
            success: false,
            message: res.error.message
          })
          return
        }

        self.$store.commit('routing/updatePickupDate', {
          id: self.pickupTimeModal.id,
          value: selectedDate.format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        })
        self.$store.commit('routing/setPickupTimeModal', {
          success: true,
          message: `Successfully updated Pkg #${self.pickupTimeModal.id}`
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.modal{
  position: fixed;
  z-index: 50;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  flex-direction: column;
  justify-content: center;
  resize: vertical;

  .bg-overlay{
    position: absolute;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .modal-content{
    position: relative;
    z-index: 2;
    background: #fff;
    min-height: 150px;
    border-radius: 6px;
    padding: 20px;
    margin: auto;
    box-shadow: 1px 1px 5px 1px rgba(0,0,0, .3);
    display: none;
  }
  &.show{
    display: flex;

    .modal-content{
      display: block;
      -webkit-animation: slide-down .15s ease-out;
      -moz-animation: slide-down .15s ease-out;
    }
  }
}
.pickup-time-modal{
  padding: 0!important;
  overflow: hidden;

  .title{
    background: #444;
    padding: 10px;
    color: #fff;
    text-align: center;
    font-weight: 600;
  }
  .box{ padding: 20px; }
  .centered{ text-align: center;}
  .fas{
    margin-bottom: 10px;
    &.fa-check{ color: #26D97A; }
    &.fa-times{ color: #f20d0d; }
  }
  .res-msg{
    margin-bottom: 30px;
    font-size: 14px;
    font-weight: 600;
  }
  .small-4{
    padding: 10px 10px 10px 0;
    &:last-child{ padding-right: 0; }
    label{
      font-size: 12px;
      line-height: 1.2;
      display: block;
    }
  }
  select{
    border: 1px solid #ddd;
    padding: 5px;
    color: #333;
    height: 36px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('/assets/img/dropdown-arrow.png');
    background-repeat: no-repeat;
    background-position: right 50%;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background-color: #eee; }
  }
  .cta.success{ margin: 10px 0 5px ; }
}

.error-msg{
  font-size: 13px;
  color: #f20d0d;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Routing/PickupDateModal.vue